import {
  DataGrid as MuiDataGrid,
  DataGridProps as MuiDataGridProps,
} from '@mui/x-data-grid';
import React from 'react';
import useTracking, { TrackingEventData } from '../../hooks/useTracking';
import { BACKGROUND, WHITE } from '../../theme';
import { EventNames } from '../../utils/trackingEvents';
import { TextColor, TextKind, textStyleFrom } from './Text';

interface DataGridProps extends MuiDataGridProps {
  trackingData?: Partial<TrackingEventData>;
}

export const DataGrid: React.FC<DataGridProps> = ({
  rows,
  columns,
  trackingData,
  ...props
}) => {
  const { track } = useTracking();

  const handlePageChange = (page: number, pageSize: number) => {
    if (trackingData) {
      track(EventNames.DataGridPagination, {
        ...trackingData,
        event_label: `Page: ${page}, Page Size: ${pageSize}`,
      });
    }
  };

  return (
    <MuiDataGrid
      data-testid="dataGrid"
      rows={rows}
      columns={columns}
      rowHeight={32}
      columnHeaderHeight={32}
      sx={{
        backgroundColor: BACKGROUND,
        '.MuiDataGrid-columnHeader': {
          background: WHITE,
        },
        '.MuiDataGrid-columnHeaderTitle': {
          ...textStyleFrom(TextKind.BodyS, TextColor.Primary, {
            bold: true,
          }),
        },
        '.MuiDataGrid-footerContainer, .MuiTablePagination-toolbar': {
          minHeight: '32px',
          background: WHITE,
        },
        'p, .MuiTablePagination-select, .MuiDataGrid-cell': {
          ...textStyleFrom(TextKind.BodyS, TextColor.Primary),
          lineHeight: undefined,
          marginTop: 0,
          marginBottom: 0,
        },
        '.MuiIconButton-root': {
          padding: '4px',
        },
        '&.MuiDataGrid-root': {
          display: 'flex',
          width: '100%',
          maxWidth: '100%',
          borderRadius: '8px',
        },
        ...props.sx,
      }}
      {...{
        rowSelection: false,
        disableRowSelectionOnClick: true,
        pageSizeOptions: [5, 10],
        onPaginationModelChange: ({ page, pageSize }) =>
          handlePageChange(page, pageSize),
        initialState: {
          pagination: {
            paginationModel: {
              page: 0,
              pageSize: 5,
            },
          },
        },
        ...props,
      }}
    />
  );
};
